// Shared helpers for the heavy families (Kiln Mauler, Sealbound Bulwark, Foundry Stomper). Render-only.
import * as THREE from 'three/webgpu';
import { at } from './kit';

export type V3 = [number, number, number];

/** Sphere placed and scaled (ellipsoid). */
export function blob(r: number, x: number, y: number, z: number, s: V3 = [1, 1, 1], ws = 12, hs = 8, rx = 0, ry = 0, rz = 0): THREE.BufferGeometry {
  return at(new THREE.SphereGeometry(r, ws, hs), x, y, z, rx, ry, rz, s);
}
/** Cone / spike pointing along +Y before rotation. */
export function spike(r: number, h: number, x: number, y: number, z: number, rx = 0, ry = 0, rz = 0, seg = 6): THREE.BufferGeometry {
  return at(new THREE.ConeGeometry(r, h, seg, 1), x, y, z, rx, ry, rz);
}
/** Short cylinder (disc / drum / piston) along +Y before rotation. */
export function drum(rt: number, rb: number, h: number, x: number, y: number, z: number, rx = 0, ry = 0, rz = 0, seg = 10): THREE.BufferGeometry {
  return at(new THREE.CylinderGeometry(rt, rb, h, seg, 1), x, y, z, rx, ry, rz);
}
/** Gait phase for a side: +X side gets 0, -X side gets PI (arms take the opposite). */
export const legPhase = (s: number) => (s > 0 ? 0 : Math.PI);
export const armPhase = (s: number) => (s > 0 ? Math.PI : 0);
